import { TableCell, TableRow } from "@material-ui/core";
import pretty from "Shared/pretty";
import React from "react";
import useStyles from "./styles";
import { DPProviderPayment } from "Shared/types/Payments";

const DailyPayPaymentRow = ({
  processedOn,
  accountNumber,
  totalAmountCents,
}: DPProviderPayment) => {
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell>
        {pretty.date(processedOn)}
      </TableCell>
      <TableCell className={classes.type}>Provider Payment</TableCell>
      <TableCell align="right">{pretty.account(accountNumber)}</TableCell>
      <TableCell className={classes.amount}>{pretty.dollar(totalAmountCents)}</TableCell>
    </TableRow>
  );
};

export default DailyPayPaymentRow;
